"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWorkflowStatusLabel = exports.getWorkflowStatusLabel = void 0;
const react_1 = require("react");
const workflow_core_1 = require("@sierralabs/workflow-core");
function getWorkflowStatusLabel(status) {
    status = status || workflow_core_1.WorkflowStatus.Draft;
    switch (status) {
        case 'draft':
            return 'Draft';
        case 'published':
            return 'Published';
        default:
            return 'Unknown Status';
    }
}
exports.getWorkflowStatusLabel = getWorkflowStatusLabel;
function useWorkflowStatusLabel(status) {
    return (0, react_1.useMemo)(() => getWorkflowStatusLabel(status), [status]);
}
exports.useWorkflowStatusLabel = useWorkflowStatusLabel;
//# sourceMappingURL=useWorkflowStatusLabel.js.map